import * as React from "react";
import {
    List,
    TextField,
    SelectField,
    BooleanField,
    CardActions,
    EditButton,
    FunctionField
} from 'react-admin';
import {
    Card,
    CardContent,
    Typography
} from '@material-ui/core';
import LegalForms from "../helper/LegalForms";
import Box from "@material-ui/core/Box";

const LegalEntityActions = ({
                             bulkActions,
                             basePath,
                             currentSort,
                             displayedFilters,
                             exporter,
                             filters,
                             filterValues,
                             onUnselectItems,
                             resource,
                             selectedIds,
                             showFilter,
                             total,
                             data
                         }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
    </CardActions>
);

const cardStyle = {
    width: "100%",
    margin: '0.5em',
    padding: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top',
    fontSize: '1.25rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    fontWeight: 500,
    lineHeight: '1.6',
    letterSpacing: '0.0075em'
};
const rowStyle = {
    margin: '0',
    lineHeight: '30px',
    padding: "3px 0",
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
};
const labelStyle = {
    display: 'inline-block',
    width: 180,
    fontSize: '1rem',
    fontWeight: 500,
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    color: 'gray'
};
const shortLabelStyle = {
    display: 'inline-block',
    width: 70,
    fontSize: '1rem',
    fontWeight: 500,
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    color: 'gray'
};
const longLabelStyle = {
    display: 'inline-block',
    width: 300,
    fontSize: '1rem',
    fontWeight: 500,
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    color: 'gray'
};

const textYesNo = {
    fontSize: '0.875rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: '1.43',
    letterSpacing: '0.01071em'
};

const Label = (prop) => {
    return (
        <span style={labelStyle}>{prop.caption}: </span>
    );
}
const ShortLabel = (prop) => {
    return (
        <span style={shortLabelStyle}>{prop.caption}: </span>
    );
}
const LongLabel = (prop) => {
    return (
        <span style={longLabelStyle}>{prop.caption}: </span>
    );
}
const YesNoField = (props) => {
    return (
        <span style={textYesNo}>{props.record[props.source] ? 'так' : 'ні'}</span>
    );
}

const ListPagination = props => <div></div>;

const statusTranslation = {
    ACTIVE: "Активне",
    SUSPENDED: "Призупинене",
    REORGANISED: "Реорганізоване",
    CLOSED: "Неактивне"
};

const LocalEntityGrid = ({ ids, data, basePath }) => (
    <div key={'common'} style={{ margin: '1em' }}>
        {ids.map(id =>
            <div key={'container-' + id} className="legal-entity-list-show">
                {localStorage.getItem('permissions') !== 'hr' ? <EditButton  record={data[id]} label={"Редагувати"} /> : null}
                <Card key={'summary-' + id} style={cardStyle}>
                    <Typography variant="h6" style={{marginBottom: '0.5em'}}>Загальна інформація</Typography>
                    <CardContent style={rowStyle}>
                        <Label caption={"ЄДРПОУ або ІПН"}/>
                        <TextField record={data[id]} source="edrpou" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Повна назва"}/>
                        <TextField record={data[id]} source="edr.name" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Публічна назва"}/>
                        <TextField record={data[id]} source="edr.publicName" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Скорочена назва"}/>
                        <TextField record={data[id]} source="edr.shortName" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Організаційно-правова форма"}/>
                        <SelectField record={data[id]} source="edr.legalForm" choices={LegalForms}/>
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"E-mail"}/>
                        <TextField record={data[id]} source="email" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Веб-сторінка"}/>
                        <TextField record={data[id]} source="website" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Тип закладу"}/>
                        <SelectField record={data[id]} source="type" choices={[
                            { id: 'PHARMACY', name: 'Аптека' }
                        ]} />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Статус"}/>
                        <FunctionField source="status" record={data[id]}
                            render={record => `${statusTranslation[record.status]}`} />
                    </CardContent>
                </Card>
                <Card key={'address-' + id} style={cardStyle}>
                    <Typography variant="h6" style={{marginBottom: '0.5em'}}>Реєстрація</Typography>
                    <CardContent style={rowStyle}>
                        <Label caption={"Місце реєстрації"}/>
                        <TextField record={data[id]} source="edr.registrationAddress.address" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Стан суб’єкта в ЄДРПОУ"}/>
                        <TextField record={data[id]} source="edr.state" />
                    </CardContent>
                </Card>
                <Card key={'kved-' + id} style={cardStyle}>
                    <Typography variant="h6" style={{marginBottom: '0.5em'}}>Види діяльності (КВЕД)</Typography>

                    {data[id].edr.kveds.map(kved =>
                        <CardContent key={'kved-item-' + kved.code} style={rowStyle}>
                            <ShortLabel caption={kved.code}/>
                            <TextField record={kved} source="name" />
                        </CardContent>
                    )}
                </Card>
                <Card key={'verification-' + id} style={cardStyle}>
                    <Typography variant="h6" style={{marginBottom: '0.5em'}}>Верифікації НСЗУ</Typography>
                    <CardContent style={rowStyle}>
                        <Label caption={"Розглянуто"}/>
                        <YesNoField record={data[id]} source="nhsReviewed" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Верифіковане"}/>
                        <YesNoField record={data[id]} source="nhsVerified" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Коментар"}/>
                        <TextField record={data[id]} source="nhsComment" />
                    </CardContent>
                </Card>
                <Card  key={'license-' + id} style={cardStyle}>
                    <Typography variant="h6" style={{marginBottom: '0.5em'}}>Ліцензія</Typography>
                    <CardContent style={rowStyle}>
                        <Label caption={"ID ліцензії"}/>
                        <TextField record={data[id]} source="license.id" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Номер ліцензії"}/>
                        <TextField record={data[id]} source="license.licenseNumber" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Категорія"}/>
                        <SelectField record={data[id]} source="license.type" choices={[
                            {id: 'PHARMACY', name: 'Аптека'},
                            {id: 'MSP', name: 'заклад з надання медичних послуг'}
                        ]}/>
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Ким видана"}/>
                        <TextField record={data[id]} source="license.issuedBy" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Дата видачі ліцензії"}/>
                        <TextField record={data[id]} source="license.issuedDate" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Початок дії ліцензії"}/>
                        <TextField record={data[id]} source="license.activeFromDate" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Ліцензія діє до"}/>
                        <TextField record={data[id]} source="license.expiryDate" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Вид діяльності, що ліцензовано"}/>
                        <TextField record={data[id]} source="license.whatLicensed" />
                    </CardContent>
                    <CardContent style={rowStyle}>
                        <Label caption={"Номер наказу"}/>
                        <TextField record={data[id]} source="license.orderNo" />
                    </CardContent>
                </Card>
            </div>
        )}
    </div>
);

LocalEntityGrid.defaultProps = {
    data: {},
    ids: [],
};

const Empty = () => {
    return (
        <Box textAlign="center" m={1}>
            <Typography variant="h4" paragraph>
                Моя організація - дані відсутні
            </Typography>
        </Box>
    );
};

export const LegalEntityList = (props) => (
    <List {...props}
        pagination={<ListPagination/>}
        title="Моя організація"
        actions={<LegalEntityActions />}
        className="list-styles"
        empty={<Empty />}
    >
        <LocalEntityGrid />
    </List>
);

export default LegalEntityList;
